import { atom } from 'jotai';

export const notificationState = atom(undefined);
